import { render, staticRenderFns } from "./AppSessions.vue?vue&type=template&id=4ad964f4&"
import script from "./AppSessions.vue?vue&type=script&lang=js&"
export * from "./AppSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports